import React from 'react';
import ConvocationPageShell from '../../components/ConvocationPageShell';
import YomSayerotStatic from './YomSayerotStatic';

const YomSayerot = () => (
  <ConvocationPageShell
    strapiApiId="convocation-yom-sayerot"
    defaultTitle="Yom Sayerot"
    StaticFallback={YomSayerotStatic}
  />
);

export default YomSayerot;
